import React from 'react';

export default function Footer({ onNavigate, onQuote }) {
  const linkStyle = {
    fontSize: '13px',
    marginBottom: '8px',
    cursor: 'pointer',
    color: 'rgba(255, 255, 255, 0.75)',
    transition: 'color 0.2s ease',
  };

  const columnHeadingStyle = {
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '13px',
    marginBottom: '12px',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <footer
      style={{
        background: 'var(--navy, #071A2B)',
        color: 'rgba(255, 255, 255, 0.75)',
        fontFamily: 'Manrope, sans-serif',
      }}
    >
      {/* CTA Band */}
      <div
        style={{
          padding: '56px 24px',
          background: 'var(--navy-light, #0C2B47)',
          borderBottom: '1px solid rgba(201, 164, 92, 0.15)',
        }}
      >
        <div
          style={{
            maxWidth: '1280px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '24px',
          }}
        >
          <div>
            <p
              style={{
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                fontSize: '12px',
                fontWeight: 700,
                color: 'var(--gold, #C9A45C)',
                fontFamily: 'Manrope, sans-serif',
                marginBottom: '8px',
              }}
            >
              Ready to travel?
            </p>
            <h3
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#ffffff',
                fontFamily: 'Manrope, sans-serif',
                margin: 0,
              }}
            >
              Let our experts plan your perfect journey.
            </h3>
            <p
              style={{
                marginTop: '4px',
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.55)',
                marginBottom: 0,
              }}
            >
              Flights, hotels, visas & holidays — arranged personally for you.
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              flexShrink: 0,
            }}
          >
            <button
              type="button"
              onClick={() => {}}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 700,
                border: '1.5px solid var(--gold, #C9A45C)',
                color: 'var(--gold, #C9A45C)',
                fontFamily: 'Manrope, sans-serif',
                background: 'transparent',
                cursor: 'pointer',
              }}
            >
              Talk to an Expert
            </button>
            <button
              type="button"
              onClick={onQuote}
              style={{
                padding: '10px 24px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 700,
                background: 'var(--gold, #C9A45C)',
                color: 'var(--navy, #071A2B)',
                fontFamily: 'Manrope, sans-serif',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Get a Quote
            </button>
          </div>
        </div>
      </div>

      {/* Links */}
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '48px 24px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '32px',
          boxSizing: 'border-box',
        }}
      >
        {/* Brand */}
        <div style={{ minWidth: '220px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '16px',
            }}
          >
            <div
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 700,
                background: 'var(--gold, #C9A45C)',
                color: 'var(--navy, #071A2B)',
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              A
            </div>
            <span
              style={{
                color: '#ffffff',
                fontWeight: 700,
                fontSize: '14px',
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              AEROVA<span style={{ color: 'var(--gold, #C9A45C)' }}> TRAVELS</span>
            </span>
          </div>
          <p
            style={{
              fontSize: '13px',
              lineHeight: 1.6,
              color: 'rgba(255, 255, 255, 0.5)',
              margin: 0,
            }}
          >
            Travel better. Go further. Your trusted India travel partner since 2014.
          </p>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              marginTop: '16px',
            }}
          >
            {['WhatsApp', 'Insta', 'FB'].map((s) => (
              <div
                key={s}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  background: 'rgba(255, 255, 255, 0.08)',
                  color: 'rgba(255, 255, 255, 0.5)',
                }}
              >
                {s[0]}
              </div>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <p style={columnHeadingStyle}>Services</p>
          {['Flight Tickets', 'Tours & Holidays', 'Visa Consultancy', 'Corporate Travel', 'Hotels'].map((s) => (
            <p
              key={s}
              onClick={() => {
                const pageMap = {
                  'Flight Tickets': 'flights',
                  'Tours & Holidays': 'tours',
                  'Visa Consultancy': 'visa',
                  'Corporate Travel': 'corporate',
                  'Hotels': 'hotels',
                };
                if (onNavigate && pageMap[s]) onNavigate(pageMap[s]);
              }}
              style={linkStyle}
            >
              {s}
            </p>
          ))}
        </div>

        {/* Destinations */}
        <div>
          <p style={columnHeadingStyle}>Popular Destinations</p>
          {['Kashmir', 'Kerala', 'Rajasthan', 'Goa', 'Himachal', 'Andaman'].map((s) => (
            <p
              key={s}
              onClick={() => onNavigate && onNavigate('tours')}
              style={linkStyle}
            >
              {s}
            </p>
          ))}
        </div>

        {/* Company */}
        <div>
          <p style={columnHeadingStyle}>Company</p>
          {[
            { label: 'About Us', page: 'about' },
            { label: 'Contact', page: 'contact' },
          ].map((link) => (
            <p
              key={link.page}
              onClick={() => onNavigate && onNavigate(link.page)}
              style={linkStyle}
            >
              {link.label}
            </p>
          ))}
          {['Client Portal', 'Blog', 'Careers'].map((s) => (
            <p key={s} style={linkStyle}>
              {s}
            </p>
          ))}
        </div>

        {/* Contact */}
        <div>
          <p style={columnHeadingStyle}>Contact Us</p>
          <p style={{ fontSize: '13px', marginBottom: '8px' }}>+91 98765 43210</p>
          <p style={{ fontSize: '13px', marginBottom: '8px' }}>hello@aerova.in</p>
          <p
            style={{
              fontSize: '13px',
              marginBottom: '16px',
              lineHeight: 1.6,
            }}
          >
            402, Prestige Tower<br />
            Banjara Hills, Hyderabad<br />
            Telangana 500034
          </p>
          <p
            style={{
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.4)',
              margin: 0,
            }}
          >
            Mon–Sat: 9:00 AM – 7:00 PM
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          padding: '16px 24px',
          borderTop: '1px solid rgba(255, 255, 255, 0.07)',
        }}
      >
        <div
          style={{
            maxWidth: '1280px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.35)',
          }}
        >
          <p style={{ margin: 0 }}>
            © 2026 Aerova Travels Pvt. Ltd. All rights reserved. GST: 36AAPCA1234A1ZX
          </p>
          <div style={{ display: 'flex', gap: '16px' }}>
            <span style={{ cursor: 'pointer' }}>Privacy Policy</span>
            <span style={{ cursor: 'pointer' }}>Terms of Service</span>
            <span style={{ cursor: 'pointer' }}>Refund Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}